{
  "overridesEnabledBadgeLabel": "Remplacements sur"
}
